






































































































































































import { Component, Vue } from 'vue-property-decorator';
import { interestAccountList } from '@/@types/Member';
import AccountDetailModal from '@/components/member/memberCommon/accountDetailModal/AccountDetailModalBase.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    AccountDetailModal,
    AccountIcon
  },
})
export default class HumanResourceCard extends Vue {
  private rating: number = 3;
  private fab: boolean = false;
  private fab2: boolean = false;
  private menu: boolean = false;
  private transition: 'slide-y-reverse-transition' = 'slide-y-reverse-transition';
  private isOpenAccountDetailDrawer: boolean = false;
  private isFavorite: boolean = false;
  private isSearchBarFocus: boolean = false;
  private accountDetailWidth: string = '450px';
/** 週間の稼働時間 */
  private weeklyFullOperationTime: number = 40;
  private concernAccountList: Array<interestAccountList> = [
    {
      accountName: 'セオリー太郎',
      age: 24,
      rating: 3.0,
      skills: ['Vue.js', 'Java', 'MySQL', 'AWS', 'Git', 'PHP', 'Laravel', 'HTML', 'CSS', 'React'],
      allProject: 30,
      comment:
        'はじめまして、よろしくお願いいたします。テストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテスト',
      desiredPayment: '2,000',
      operationTime: 40,
      joinStartDate: '2020/04/01',
      workStyle: 'リモート',
      newRegisterFlag: false,
      recommendedFlag: false,
      isFavorite: false,
    },
    {
      accountName: 'セオリー太郎',
      age: 24,
      rating: 3.0,
      skills: ['Vue.js', 'Java', 'MySQL', 'AWS', 'Git', 'PHP', 'Laravel', 'HTML', 'CSS', 'node'],
      allProject: 30,
      comment:
        'はじめまして、よろしくお願いいたします。テストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテスト',
      desiredPayment: '2,000',
      operationTime: 35,
      joinStartDate: '2020/04/01',
      workStyle: 'リモート',
      newRegisterFlag: false,
      recommendedFlag: false,
      isFavorite: false,
    },
    {
      accountName: 'セオリー太郎',
      age: 24,
      rating: 3.0,
      skills: ['Vue.js', 'Java', 'MySQL', 'AWS', 'Git', 'PHP', 'Laravel', 'HTML', 'CSS', 'TypeScript'],
      allProject: 30,
      comment:
        'はじめまして、よろしくお願いいたします。テストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテスト',
      desiredPayment: '2,000',
      operationTime: 40,
      joinStartDate: '2020/04/01',
      workStyle: 'リモート',
      newRegisterFlag: false,
      recommendedFlag: false,
      isFavorite: false,
    },
    {
      accountName: 'セオリー太郎',
      age: 24,
      rating: 3.0,
      skills: ['Vue.js', 'Java', 'MySQL', 'AWS', 'Git', 'PHP', 'Laravel', 'HTML', 'CSS'],
      allProject: 30,
      comment:
        'はじめまして、よろしくお願いいたします。テストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテストテスト',
      desiredPayment: '2,000',
      operationTime: 40,
      joinStartDate: '2020/04/01',
      workStyle: 'リモート',
      newRegisterFlag: false,
      recommendedFlag: false,
      isFavorite: false,
    },
  ];

  private closeAccountDetailDrawer(): void {
    this.isOpenAccountDetailDrawer = false;
  }
  private openAccountDetailDrawer(): void {
    this.isOpenAccountDetailDrawer = true;
  }

  private changeFavorite(isFavorite: boolean, index: number): boolean {
    if (!isFavorite) {
      return this.concernAccountList[index].isFavorite = true;
    } else {
      return this.concernAccountList[index].isFavorite = false;
    }
  }

  private starColor(isFavorite: boolean): 'yellow darken-1' | '#bdbdbd' {
    if (isFavorite) {
      return 'yellow darken-1';
    } else {
      return '#bdbdbd';
    }
  }

  private SearchBarFocusFlat(): boolean {
    if (this.isSearchBarFocus) {
      return false;
    }
    return true;
  }
}
